import {Injectable} from '@angular/core';
import {Subject, throttleTime} from 'rxjs';

@Injectable({
	providedIn: 'root',
})
export class ScrollService {
	private scrollSubject = new Subject<void>();
	public scrollObservable = this.scrollSubject.asObservable().pipe(
		// Throttling limits the frequency at which your scroll event handler is called, improving performance by preventing excessive computations or DOM manipulations.
		throttleTime(300) // Throttle time in milliseconds.
	);

	public emitScrollEvent(): void {
		this.scrollSubject.next();
	}

	private scrolledDownSubject = new Subject<void>();
	public scrolledDownObservable = this.scrolledDownSubject.asObservable();

	public emitscrolledDownEvent(): void {
		this.scrolledDownSubject.next();
	}

	private scrolledUpSubject = new Subject<void>();
	public scrolledUpObservable = this.scrolledUpSubject.asObservable();

	public emitscrolledUpEvent(): void {
		this.scrolledUpSubject.next();
	}
}
